import { MatSort, SortDirection } from '@angular/material/sort';
import { filter, map, Observable } from 'rxjs';
import { sort } from '../utils';
import {
  PIPE_ORDER,
  QtDataSourceContext,
  QtDataTransformAdapter,
} from './qt-control-adapter';

export interface SortState {
  id?: string;
  start: SortDirection;
}

export class SortAdapter implements QtDataTransformAdapter<any, SortState> {
  readonly key = 'sort';
  readonly pipeOrder = PIPE_ORDER.SORT;

  private _suppress = false;
  private _ctx: QtDataSourceContext | null = null;
  private _default: SortState | null = null;

  readonly valueChanges$: Observable<SortState> = this.matSort.sortChange.pipe(
    filter(() => !this._suppress),
    map(s => ({ id: s.active, start: s.direction }))
  );

  get operator() {
    return sort<any>(
      this.matSort,
      this._ctx
        ? (this._ctx.sortValueAccessorFn ?? this._ctx.valueAccessorFn)
        : () => undefined
    );
  }

  constructor(readonly matSort: MatSort) {}

  setContext(ctx: QtDataSourceContext): void {
    this._ctx = ctx;
  }

  applyValue(value: SortState): void {
    if (!value) return;
    this._suppress = true;
    this.matSort.sort({
      id: value.id ?? '',
      start: value.start,
      disableClear: true,
    });
    this._suppress = false;
  }

  getValue(): SortState {
    return { id: this.matSort.active, start: this.matSort.direction };
  }

  /** Fallback sort used only when the user has no saved sort for this table. */
  setDefault(value: SortState | null): void {
    this._default = value;
  }

  applyDefault(): void {
    // A ?active/&direction query param (QtRouterSerializer) already won.
    if (!this._default || this.matSort.active) return;
    this.applyValue(this._default);
  }
}
